import { PropsWithChildren } from "react";
import { Link } from "react-router";
import styles from "./Panel.module.css";

type Props = PropsWithChildren<{
  title?: string;
  link?: Link;
}>;

interface Link {
  to: string;
  text: string;
}

const Panel = ({ title, link, children }: Props) => {
  return (
    <article className={styles.panel}>
      {title && (
        <header className={styles.title}>
          <h3>{title}</h3>
          {link && <Link to={link.to}>{link.text}</Link>}
        </header>
      )}
      {children}
    </article>
  );
};

export default Panel;
